import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesOnlineAddressMain } from './modules/ui/Main';

const OnlineAddressPage = (
  <SuspensePage>
    <PagesOnlineAddressMain />
  </SuspensePage>
);

export default OnlineAddressPage;
